import { Button } from "V2.0/common/button";
import { Badge } from "V2.0/common/badge";
import NodeExecutionStatusBadge from "./NodeExecutionStatus";
import PreviewJson from "./PreviewJson";
import { formatTime } from "V2.0/utils";

export {
  NodeExecutionAction,
  NodeExecutionTiming,
  NodeExecutionName,
  NodeExecutionOutputPort,
  NodeExecutionDataPreview,
  NodeExecutionStatus,
};

function NodeExecutionTiming(props) {
  const { timestamp, label } = props;

  if (!timestamp) return null;

  return (
    <div className="flex items-center gap-x-2">
      <p className="text-sm">{label}</p>
      <p className="text-sm">{formatTime(timestamp)}</p>
    </div>
  );
}

function NodeExecutionOutputPort(props) {
  const { outputPort } = props;

  if (!outputPort) return null;

  return (
    <div className="flex items-center gap-x-2">
      <p className="text-sm">Output Port:</p>
      <Badge color="emerald">{outputPort}</Badge>
    </div>
  );
}

function NodeExecutionDataPreview(props) {
  const { title, data } = props;

  if (!data) return null;

  return (
    <PreviewJson
      title={title}
      data={data}
    />
  );
}

function NodeExecutionAction(props) {
  const { onClose } = props;
  return (
    <div className="flex justify-end gap-x-2 items-center">
      <Button
        outline
        onClick={onClose}
      >
        Close
      </Button>
    </div>
  );
}

function NodeExecutionStatus(props) {
  const { status } = props;

  if (!status) return null;

  return (
    <div className="flex items-center gap-x-2">
      <p className="text-sm">Status:</p>
      <NodeExecutionStatusBadge status={status} />
    </div>
  );
}

function NodeExecutionName(props) {
  const { name } = props;

  return <p>{name}</p>;
}
